<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in data.body"
      :key="sliceIndex"
      :slice="slice"
      :primary="slice.primary"
      :items="slice.items"
    />
  </div>
</template>

<script>
import { Hero, LogoBanner, TrustpilotCarousel, ProcessArrow, SimpleCta } from '@@/shared-slices'

import { QuinconceSlice } from '~/components/slices'

export default {
  components: {
    hero: Hero,
    logo_banner: LogoBanner,
    process_arrow: ProcessArrow,
    quinconce_block: QuinconceSlice,
    trustpilot_carousel: TrustpilotCarousel,
    simple_cta: SimpleCta,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
